import React, {Component} from 'react';
import {Alert, Button, Card, CardBody, CardTitle} from 'reactstrap';
import {I18n} from '../../../I18n/components/promoPage';
import {
    deleteSingleOffer,
    fetchBasicOfferPrefs,
    fetchLocalizedOfferPrefs,
    fetchOffers,
    updateSingleOffer
} from '../../../actions/promoActions';
import {closeAlert} from "../../../actions/commonsActions";
import {push} from "connected-react-router";
import {USER_ROLES} from '../../../helpers/constants';
import {connect} from 'react-redux';
import OfferList from "../OfferList/OfferList";
import DeleteModal from '../DeleteModal/DeleteModal';
import './offersPage.css';

class OffersPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            selectedApp: {},
            currentLocation: '',
            isDeleteModal: false,
            activeOfferId: null
        }
    }

    componentDidMount() {
        (async () => {
            try {
                const {location} = this.props;
                await this.props.fetchOffers({
                    page: 0,
                });
                this.props.fetchLocalizedOfferPrefs({
                    lang: this.props.lang
                });
                this.props.fetchBasicOfferPrefs();
                this.setState({
                    currentLocation: location.pathname
                }, () => {
                    console.log('offers page state', this.state);
                });
            } catch (error) {
                console.error(error)
            }
        })();
    }

    fetchPaginatedData = currentPage => {
        this.props.fetchOffers({
            page: currentPage
        }).then(() => {
            this.setState({
                currentPage,
            });
        })
    };

    setCurrentPage = currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };

    onEditOffer = (id) => {
        console.log(id, this.props.offers.find(offer => offer.id === id));
        this.props.changeLocation({
            pathname: `/dashboard/offer/${id}`,
            state: {
                backTo: this.state.currentLocation,
                offer: this.props.offers.find(offer => offer.id === id)
            }
        })
    };

    onStopOffer = (id) => {
        const offer = this.props.offers.find(offer => offer.id === id);
        this.props.updateSingleOffer({
            ...offer,
            status: 'CANCELED'
        }).then(() => {
            this.fetchPaginatedData(0);
        })
    };

    onStartOffer = (id) => {
        const offer = this.props.offers.find(offer => offer.id === id);
        this.props.updateSingleOffer({
            ...offer,
            status: 'ACTIVE'
        }).then(() => {
            this.fetchPaginatedData(0);
        })
    };

    isDeleteModalToggle = (id) => {
        this.setState({
            isDeleteModal: !this.state.isDeleteModal,
            activeOfferId: id
        })
    };

    deleteOffer = () => {
        if (this.state.activeOfferId) {
            this.props.deleteSingleOffer(this.state.activeOfferId)
                .then(() => {
                    this.setState({
                      isDeleteModal: !this.state.isDeleteModal,
                      activeOfferId: null
                    }, () =>  this.fetchPaginatedData(0))
                })
        }
    };

    render() {
        const {lang, loading} = this.props;
        console.log('offerList', this.state, this.props)
        const offerList = loading
            ? <div className="loading">Loading...</div>
            : <OfferList
                lang={this.props.lang}
                offers={this.props.offers}
                basicOfferPrefs={this.props.basicOfferPrefs}
                currentPage={this.state.currentPage}
                setCurrentPage={this.setCurrentPage}
                totalPages={this.props.pagination.totalPages}
                onEditOffer={this.onEditOffer}
                onStopOffer={this.onStopOffer}
                onStartOffer={this.onStartOffer}
                isDeleteModalToggle={this.isDeleteModalToggle}
                />

        return (
            <div className='offers-page '>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
                </Alert>
                <DeleteModal
                    isOpen={this.state.isDeleteModal}
                    onDelete={this.deleteOffer}
                    toggle={() => this.isDeleteModalToggle(null)}
                    lang={lang}
                />
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-border-right mr-2"></i>
                            {I18n[lang].companies}
                        </div>
                        <Button
                            className="offers-page__offerBtn"
                            color="primary"
                            type="button"
                            onClick={() => this.props.changeLocation('/dashboard/offer')}
                        >
                            {I18n[lang].promo}
                        </Button>
                    </CardTitle>
                    <CardBody className="toast-promo__body">
                        {offerList}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        fetchOffers: query => dispatch(fetchOffers(query)),
        fetchLocalizedOfferPrefs: query => dispatch(fetchLocalizedOfferPrefs(query)),
        fetchBasicOfferPrefs: () => dispatch(fetchBasicOfferPrefs()),
        updateSingleOffer: offer => dispatch(updateSingleOffer(offer)),
        deleteSingleOffer: id => dispatch(deleteSingleOffer(id)),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    loading: state.offersList.loading,
    authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    lang: state.languageReducer.lang,
    offers: state.offersList.offers,
    localizedOfferPrefs: state.localizedOfferPrefsList.prefs,
    basicOfferPrefs: state.basicOfferPrefsList.prefs,
    pagination: state.offersList.pagination
});

export default connect(mapStateToProps, mapDispatchToProps)(OffersPage)


// WEBPACK FOOTER //
// ./src/components/Promo/OffersPage/OffersPage.js